const ServiceFund = () => import('./ServiceFund')

export default function install(Vue) {
  Vue.component('form-service-fund', ServiceFund)
}
